<template>
  <div :class="$style.list">
    <h3>{{ data.year }}</h3>
    <ul>
      <li v-for="(el, index) in data.text_list" :key="index">
        <label>{{ el.month }}</label>
        <span>{{ el.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
}
</script>

<style lang="less" module>
.list {
  margin: 0 0.55rem;
  cursor: default;

  h3 {
    margin-bottom: 1em;
    padding-bottom: 0.5em;
    font-size: 24px;
    font-weight: 200;
    border-bottom: 0.01rem solid #dbdcdf;
  }

  li {
    display: flex;
    line-height: 1.5;

    &:not(:first-child) {
      margin-top: 1em;
    }

    label {
      flex: 0 0 3em;
      margin-right: 1em;
    }

    span {
      flex: 1;
      display: block;
    }
  }

  @media screen and (max-width: @mini-width) {
    h3 {
      font-size: 18px;
    }

    li {
      font-size: 12px;
    }
  }
}
</style>
